module.exports = __webpack_public_path__ + "static/media/tv.29ec9648.jpg";